<template>
  <small-modal
    :fit-content="true"
    :show-close-button="false"
    class="filter-modal"
    @close="$emit('close-filter-modal')"
  >
    <div class="campaign-filter-container">
      <h1 class="filter">{{ $t("campaignManager.filter.filters") }}</h1>
      <span class="reset" @click="resetFilters">{{
        $t("campaignManager.filter.reset")
      }}</span>
      <form class="filter-wrapper">
        <div v-if="isAddToCartModal && showLanguageFilter" class="filter-block">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.languages") }}
            </h2>
          </label>
          <v-select
            :value="selectedLanguages"
            class="dropdown scrollable-dropdown"
            :options="languagesOptions"
            label="language"
            :reduce="(opt) => opt.language"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { languages: val })"
          />
        </div>
        <div>
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.categories") }}
            </h2>
          </label>
          <v-select
            :value="selectedCategories"
            class="dropdown scrollable-dropdown"
            :options="categoriesOptions"
            label="category"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { categories: val })"
          ></v-select>
        </div>
        <div v-if="integration === 'shopify'">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.collections") }}
            </h2>
          </label>
          <v-select
            :value="selectedCollections"
            class="dropdown scrollable-dropdown"
            :options="collectionsOptions"
            label="collections"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { collections: val })"
          ></v-select>
        </div>
        <div v-if="false">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.languages") }}
            </h2>
          </label>
          <v-select
            v-model="selectedFilters.languages"
            class="dropdown scrollable-dropdown"
            :options="languagesOptions"
            label="language"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { languages: val })"
          ></v-select>
        </div>
        <div>
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.brands") }}
            </h2>
          </label>
          <v-select
            :value="selectedBrands"
            class="dropdown scrollable-dropdown"
            :options="brandsOptions"
            label="brand"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { brands: val })"
          ></v-select>
        </div>
        <div v-if="!isAddToCartModal" class="filter-block">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.videos") }}
            </h2>
          </label>
          <v-select
            :value="selectedHasVideos"
            class="dropdown scrollable-dropdown"
            :options="videoOptions"
            label="label"
            :reduce="(opt) => opt.value"
            :clearable="true"
            :placeholder="placeholder"
            @input="onHasVideosChange"
          />
        </div>
        <div>
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.stock") }}
            </h2>
          </label>
          <v-select
            :value="selectedHasStock"
            class="dropdown scrollable-dropdown"
            :options="stockOptions"
            label="label"
            :reduce="(opt) => opt.value"
            :clearable="true"
            :placeholder="placeholder"
            @input="onHasStockChange"
          />
        </div>
        <div v-if="integration === 'shopify'">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.productStatus") }}
            </h2>
          </label>
          <v-select
            :value="selectedStatus"
            class="dropdown scrollable-dropdown"
            :options="statusOptions"
            label="label"
            :reduce="(opt) => opt.value"
            multiple
            :clearable="true"
            :placeholder="placeholder"
            @input="onStatusChange"
          />
        </div>
      </form>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SmallModal,
  },
  props: {
    categoriesOptions: {
      type: Array,
      required: true,
    },
    collectionsOptions: {
      type: Array,
      required: true,
    },
    languagesOptions: {
      type: Array,
      required: true,
    },
    brandsOptions: {
      type: Array,
      required: true,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    selectedCollections: {
      type: Array,
      default: () => [],
    },
    selectedBrands: {
      type: Array,
      default: () => [],
    },
    selectedHasVideos: {
      type: Boolean,
      default: null,
    },
    isAddToCartModal: {
      type: Boolean,
      default: false,
    },
    showLanguageFilter: {
      type: Boolean,
      default: false,
    },
    selectedLanguages: {
      type: Array,
      default: () => [],
    },
    selectedHasStock: {
      type: Boolean,
      default: null,
    },
    selectedStatus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      placeholder: this.$t("campaignManager.filter.select"),
      videoOptions: [
        { label: this.$t("productPages.filters.haveVideos"), value: true },
        { label: this.$t("productPages.filters.noVideos"), value: false },
      ],
      stockOptions: [
        { label: this.$t("productPages.filters.haveStock"), value: true },
        { label: this.$t("productPages.filters.noStock"), value: false },
      ],
      statusOptions: [
        { label: this.$t("productPages.filters.statusDraft"), value: "draft" },
        { label: this.$t("productPages.filters.statusLive"), value: "active" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      integration: "site/siteIntegration",
    }),
  },
  methods: {
    resetFilters() {
      this.$emit("filter", {
        categories: [],
        collections: [],
        brands: [],
        productName: "",
        hasVideos: null,
        languages: [],
        hasStock: null,
        productStatus: [],
      });
      this.$emit("reset");
    },
    onHasVideosChange(value) {
      this.$emit("video-filter", { hasVideos: value });
    },
    onHasStockChange(value) {
      this.$emit("stock-filter", { hasStock: value });
    },
    onStatusChange(values) {
      this.$emit("status-filter", { status: values });
    },
  },
};
</script>

<style lang="scss">
.filter-modal .small-modal.fit-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  top: 130px;
  left: 32%;
  transform: translate(0, 0);
  width: 210px;
}
.dropdown {
  .vs__dropdown-toggle {
    max-height: 30px !important;
    min-height: 30px !important;
  }
  .vs__search {
    font-family: Montserrat;
    color: $light-grey;
    font-size: 14px;
    font-weight: 400;
  }
  .vs__selected-options {
    flex-wrap: wrap !important;
  }
  .vs__dropdown-option {
    padding-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vs__dropdown-menu {
    position: absolute !important;
  }

  .vs__dropdown-menu {
    min-height: 30px !important;
    max-height: 200px !important;
    overflow: auto !important;
    flex-wrap: wrap;
  }
}

.scrollable-dropdown {
  .vs__dropdown-menu {
    min-height: 30px !important;
    max-height: 200px !important;
    overflow: auto !important;
    flex-wrap: wrap;
  }
}
.v-select.dropdown.scrollable-dropdown.vs--multiple.vs--searchable.vs__dropdown-toggle {
  height: auto !important;
}
</style>

<style lang="scss" scoped>
.modal-background {
  background: transparent;
}

.filter {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: default;
  margin-bottom: 14px;
}
.reset {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: $light-grey;
  position: fixed;
  top: 16px;
  right: 16px;
  cursor: pointer;
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-type-title {
  margin-bottom: 8px;
}
</style>
